export default "{\n    \"emptyState\": {\n        \"label\": \"Coming soon\"\n    }\n}\n"